import React from "react";
import { CardContent, Avatar, Typography, Card, Box, Chip,IconButton } from "@mui/material";
import SettingsIcon from '@mui/icons-material/Settings';
const UserProfile = ({ user }) => {
    const handleDelete = function(){
        console.log("Delete");
    }

    if (!user) {
        return <Typography>로그인이 필요합니다.</Typography>;
    }

    return (
    <Card sx={{ display: "flex", alignItems: "center", borderRadius: 2, boxShadow: 2 }}>
        <Avatar 
        src={user.user_metadata?.avatar_url || "https://via.placeholder.com/100"} 
        alt="User Avatar" 
        sx={{ width: 60, height: 60, mr: 1, ml:2 }}
        />
        <CardContent>
            <Box sx={{display:"flex",flexDirection:"row",gap:1,alignItems:"center"}}>
                <Typography variant="h6">{user.user_metadata?.full_name || "사용자"}</Typography>
                <IconButton size="small"><SettingsIcon /></IconButton>
            </Box>
            <Typography variant="body2" color="text.secondary">{user.email}</Typography>
            <Box
                sx={{
                display: "flex",
                flexDirection: "row",
                overflowX: "auto",
                gap: 0.5,
                mt: 1,
                "&::-webkit-scrollbar": {
                    height: "6px",
                },
                "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#ccc",
                    borderRadius: "4px",
                },
                }}
            >
                <Chip label="서울시" onDelete={handleDelete} size="small" />
                <Chip label="도봉구" onDelete={handleDelete} size="small" />
                <Chip label="남아" onDelete={handleDelete} size="small" />
                <Chip label="3세" onDelete={handleDelete} size="small" />
            </Box>
        </CardContent>
    </Card>
    );
};

export default UserProfile;
